import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { QuestionAttemptStoreModel } from '@examdojo/question';
import { DatasetUploadDialogComponent } from './dataset-upload-dialog.component';

export interface DatasetUploadDialogInput {
  attemptId: QuestionAttemptStoreModel['id'];
}

@Injectable({ providedIn: 'root' })
export class DatasetUploadDialogService extends AbstractDialogService<
  DatasetUploadDialogInput,
  void,
  typeof DatasetUploadDialogComponent
> {
  override readonly id = 'dataset-upload-dialog';
  protected override readonly component = DatasetUploadDialogComponent;

  override readonly options: DialogOptions = {
    cssClass: 'auto-height',
    canDismiss: true,
    backdropDismiss: true,
    showBackdrop: true,
    handle: false,
  };

  override async openDialog(options?: {
    input?: DatasetUploadDialogInput;
    options?: DialogOptions;
    isSingleBreakpoint?: boolean;
    beforeDismissCallback?: () => unknown | Promise<unknown>;
  }) {
    if (options?.input?.attemptId) {
      this.assignComponentProperty('attemptId', options.input.attemptId);
    }
    return super.openDialog(options);
  }
}
